import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { Layout, Typography, message, ConfigProvider } from 'antd'
import axios from 'axios'
import LoadingFullScreen from '../../components/LoadingFullScrren'

const PricingTable = () => {
    const { id: tableId } = useParams()
    const [loading, setLoading] = useState(true)
    const [tableData, setTableData] = useState(null)
    const [brandData, setBrandData] = useState(null)
    const [error, setError] = useState(null)

    const fetchPricingTable = async () => {
        try {
            setLoading(true)

            // TODO: Remove this mock data and uncomment the real API call when CORS is fixed
            // const mockResponse = {
            //     data: {
            //         team: 'team_86zUNzJbu9Nz',
            //         table: '<script async src="https://js.stripe.com/v3/pricing-table.js"></script>\n<stripe-pricing-table pricing-table-id="prctbl_1Rc86VEjMX9SyOCOBrn2Rvco"\npublishable-key="pk_test_51QSfPUEjMX9SyOCO1BFwYqAf2PrjXFuTj1js5LeqFsYSKMgncxRMqhm5QQgXwcdsIT1glfTrZTzi2z7dIbrlFKhf00iOnlrox0">\n</stripe-pricing-table>',
            //         id: 'pt_91RKnFpXAtGWGTYaFodg',
            //         brand: {
            //             primaryColor: '#044737',
            //             secondaryColor: '#adeabb',
            //             logo: 'https://firebasestorage.googleapis.com/v0/b/gigstackpro.appspot.com/o/teams%2Fteam_86zUNzJbu9Nz%2Ffiles%2Flogo?alt=media&token=c6b1bdc4-a82c-4226-bd80-3c2d838e34ce',
            //             alias: 'Caffé Lattea',
            //         },
            //     },
            // }

            // // Simulate API delay
            // await new Promise((resolve) => setTimeout(resolve, 1000))

            // const response = mockResponse

            // Real API call (commented out due to CORS issues in development)
            // const testUrl = 'http://127.0.0.1:5001/gigstackpro/us-central1/pricingTables'
            const url = 'https://us-central1-gigstackpro.cloudfunctions.net/pricingTables'
            const response = await axios.get(url, {
                params: {
                    tableId: tableId,
                },
            })

            if (response.data && response.data.table) {
                setTableData(response.data.table)
                setBrandData(response.data.brand)
            } else {
                setError('No se encontró la tabla de precios')
            }
        } catch (error) {
            console.error('Error fetching pricing table:', error)
            if (error.message && error.message.includes('CORS')) {
                setError(
                    'Error de CORS: Esta funcionalidad requiere que el servidor esté configurado correctamente. Funciona en producción.',
                )
            } else {
                setError('Error al cargar la tabla de precios')
            }
            message.error('Error al cargar la tabla de precios')
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (tableId) {
            fetchPricingTable()
        }
    }, [tableId])

    // Effect to inject the Stripe script when tableData is available
    useEffect(() => {
        if (tableData && !loading) {
            // Create a script element and inject the pricing table HTML
            const container = document.getElementById('pricing-table-container')
            if (container) {
                container.innerHTML = tableData

                // Execute any scripts that might be in the HTML
                const scripts = container.querySelectorAll('script')
                scripts.forEach((script) => {
                    const newScript = document.createElement('script')
                    if (script.src) {
                        newScript.src = script.src
                    } else {
                        newScript.textContent = script.textContent
                    }
                    script.parentNode?.replaceChild(newScript, script)
                })

                // Add custom CSS to make Stripe pricing table full width
                const customStyles = document.createElement('style')
                customStyles.textContent = `
                    stripe-pricing-table {
                        width: 100% !important;
                        max-width: 100% !important;
                    }
                    
                    stripe-pricing-table::part(base) {
                        width: 100% !important;
                        max-width: 100% !important;
                    }
                    
                    stripe-pricing-table::part(pricing-table) {
                        width: 100% !important;
                        max-width: 100% !important;
                    }
                    
                    stripe-pricing-table::part(pricing-table-container) {
                        width: 100% !important;
                        max-width: 100% !important;
                    }
                    
                    /* Force the table to be full width */
                    #pricing-table-container stripe-pricing-table {
                        display: block !important;
                        width: 100% !important;
                        box-sizing: border-box !important;
                    }
                `
                document.head.appendChild(customStyles)
            }
        }
    }, [tableData, loading])

    if (loading) {
        return <LoadingFullScreen loading={true} />
    }

    return (
        <ConfigProvider
            theme={{
                token: {
                    colorPrimary: brandData?.primaryColor || '#00b96b',
                    colorLink: brandData?.primaryColor || '#00b96b',
                    colorText: '#333',
                    colorTextSecondary: '#333',
                },
            }}
        >
            <Layout style={{ padding: 0, margin: 0 }}>
                <Layout.Content
                    style={{
                        minHeight: '100vh',
                        width: '100vw',
                        backgroundColor: '#F7F9FB',
                        padding: '20px',
                        margin: 0,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    {error ? (
                        <div style={{ textAlign: 'center', marginTop: '50px' }}>
                            <Typography.Title level={3} type="danger">
                                {error}
                            </Typography.Title>
                            <Typography.Text>
                                Por favor verifica que el enlace sea correcto o contacta al soporte.
                            </Typography.Text>
                        </div>
                    ) : tableData ? (
                        <div style={{ width: '100%', maxWidth: '100%' }}>
                            {brandData && (
                                <div
                                    style={{
                                        textAlign: 'center',
                                        marginBottom: '30px',
                                        padding: '20px',
                                    }}
                                >
                                    {brandData.logo && (
                                        <img
                                            src={brandData.logo}
                                            alt={brandData.alias || 'Brand Logo'}
                                            style={{
                                                maxHeight: '80px',
                                                marginBottom: '15px',
                                                borderRadius: '8px',
                                            }}
                                        />
                                    )}
                                    {brandData.alias && (
                                        <Typography.Title
                                            level={2}
                                            style={{
                                                color: brandData.primaryColor,
                                                marginBottom: '10px',
                                            }}
                                        >
                                            {brandData.alias}
                                        </Typography.Title>
                                    )}
                                </div>
                            )}
                            <div
                                id="pricing-table-container"
                                style={{
                                    width: '100%',
                                    display: 'block',
                                    margin: '0 auto',
                                    padding: '0 20px',
                                    boxSizing: 'border-box',
                                }}
                            />
                        </div>
                    ) : (
                        <div style={{ textAlign: 'center', marginTop: '50px' }}>
                            <Typography.Title level={3}>
                                No se encontraron datos de la tabla de precios
                            </Typography.Title>
                        </div>
                    )}
                </Layout.Content>
            </Layout>
        </ConfigProvider>
    )
}

export default PricingTable
